<template>
  <div class="zy-health step-number-page">
    <!-- 顶部导航栏 - 参考 heartRateDetails 页面 -->
    <header class="step-number-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <button 
          class="nav-back-btn" 
          @click="goBack"
          :style="{top: (statusBarHeight + 12) + 'px'}"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <div class="nav-title">步数</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="step-number-content" :style="{paddingTop: (statusBarHeight + 80) + 'px'}">
      <!-- 分段控制器 - 参考 heartRateDetails 页面 -->
      <div class="segmented-control">
        <div 
        v-for="(tab, index) in tabs"
        :key="index"
          class="segment-item" 
          :class="{ active: activeTab === index }" 
        @click="selectTab(index)"
      >
        {{ tab }}
        </div>
      </div>
     
    <div class="tab-content">
      <div v-if="activeTab === 0">
        <dailySteps></dailySteps>
      </div>
      <div v-if="activeTab === 1">
        <monthlySteps></monthlySteps>
      </div>
      <div v-if="activeTab === 2">
          <annualSteps></annualSteps>
        </div>
      </div>

      <!-- 免责声明 + 开始分析（参考血氧页；仅聚合页 Tab 内嵌时展示按钮） -->
      <div class="health-disclaimer">
        <p>注:非医疗设备,结果仅供参考,如有不适,请及时就医</p>
        <StartAnalysisCta :embedded="embedded" @click="$emit('start-analysis')" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import StartAnalysisCta from '@/components/StartAnalysisCta'

export default {
  name: 'stepNumber',
  props: {
    /**
     * 是否为聚合页 Tab 内嵌场景（内嵌时才展示开始分析按钮）
     * @type {boolean}
     */
    embedded: { type: Boolean, default: false },
    value: { type: [String, Number, Boolean, Object, Array], default: undefined }
  },
  data() {
    return {
      activeTab: 0,
      animate: false,
      tabs: ["日", "周", "月"],
    };
  },
  components: {
    dailySteps: () => import("./dailySteps"),
    monthlySteps: () => import("./monthlySteps"),
    annualSteps: () => import("./annualSteps"),
    StartAnalysisCta,
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
  },

  mounted() {
    document.title = '步数' 
    console.log(localStorage.getItem('oldAge'))
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "50px";
        }
    // 设置 body 背景色，确保滚动时背景色不丢失
    document.body.style.backgroundColor = '#F2F3F5';
    // this.setRem();
    // window.addEventListener("resize", this.setRem);
  },
  beforeDestroy() {
    // 恢复 body 背景色
    document.body.style.backgroundColor = '';
    // window.removeEventListener("resize", thsis.setRem);
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    // setRem() {
    //   const baseSize = 16; // 假设基准字体大小为16px
    //   const designWidth = 375; // 设计稿宽度，通常以iPhone 6为基准
    //   const docEl = document.documentElement;
    //   const rem = (docEl.clientWidth / designWidth) * baseSize;
    //   docEl.style.fontSize = `${rem}px`;
    // },
    // 监听tab栏切换
    selectTab(index) {
      this.activeTab = index;
    },
  },
};
</script>

<style lang="less" scoped>
.step-number-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 20px;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
  
  /* 顶部导航栏 - 参考 heartRateDetails 页面 */
  .step-number-header {
    position: relative;
    width: 100%;
    min-height: 220px;
    overflow: hidden;
    margin-bottom: 0;
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .header-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .header-nav {
    position: relative;
    z-index: 100;
  display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    min-height: 44px;
  }

  .nav-back-btn {
    position: fixed;
    left: 16px;
    z-index: 1000;
    width: 28px;
    height: 28px;
  padding: 0;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

  .nav-back-btn i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .nav-back-btn:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-back-btn:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .nav-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .nav-placeholder {
    flex-shrink: 0;
    width: 28px;
}

  /* 内容区域 */
  .step-number-content {
    width: 100%;
    padding: 16px;
  position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
  }

  /* 分段控制器 - 参考 heartRateDetails 页面 */
  .segmented-control {
    display: flex;
    background-image: url('~@/assets/heartRate/Rectangle_346242043@2x (1).png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 8px;
    padding: 4px;
    margin: 0 0 16px 0;
    gap: 4px;
  }

  .segment-item {
    flex: 1;
    text-align: center;
    padding: 10px 0;
    font-size: 15px;
    color: #666666;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 8px;
    font-weight: 400;
    position: relative;
    overflow: hidden;
  }

  .segment-item.active {
    background-image: url('~@/assets/healthReportList/tab.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    color: #ffffff;
    font-weight: 500;
  }

  .segment-item:active {
    opacity: 0.8;
  }

.tab-content {
}
}
</style>




// WEBPACK FOOTER //
// src/views/stepNumber/index.vue